//
// import Vue from 'vue'
// import VueRouter from 'vue-router'
// import HomeView from '../views/HomeViewcopy.vue'
// import Layout from '../views/Layout.vue'
//
// Vue.use(VueRouter)
//
// const routes = [
//   {
//     path:'',
//     name:'layout',
//     component:Layout,
//     children:[
//       {
//         path: '/',
//         name: 'home',
//         component: HomeView
//       },
//       {
//         path: '/about',
//         name: 'about',
//         component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
//       }
//     ]
//   },
//
//
//
// ]
//
// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })
//
// export default router


import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Layout from '../views/Layout.vue'
import Login from '@/views/login.vue'; // 引入login.vue组件
import Register from '@/views/register.vue';
import changePassword from "@/views/changePassword.vue";
import InformationAdmin from "@/views/InformationAdmin.vue";
import historicalRecords from "@/views/historicalRecords.vue";
import inspection from "@/views/inspection.vue";
import concept from "@/views/concept.vue";//概念验证
import sandTable from "@/views/sandTable.vue";//概念验证
import industryChain from "@/views/components/IndustryChain.vue";
import Industry from "@/views/Industry.vue";
import copy from "@/views/copy.vue";
import execl from "@/views/execl.vue";
import ZhiqiTong1 from "@/views/ZhiqiTong1.vue";
import ZhiqiTong2 from "@/views/ZhiqiTong2.vue";
import ZhiqiTong3 from "@/views/ZhiqiTong3.vue";
import ZhiqiTong4 from "@/views/ZhiqiTong4.vue";
import ZhiqiTongNew from "@/views/ZhiqiTongNew.vue";
import ImgShow from "@/views/imgShow.vue";
import display from "@/views/secondInstance/display.vue";
import MySecondLevel from "@/views/secondInstance/mySecondLevel.vue";
import PersonalInformation from "@/views/PersonalInformation .vue";
// import
import  conceptCopy from "@/views/conceptCopy.vue";
import zhiqiTongCopy from "@/views/ZhiqiTongCopy.vue";
import ZhiqiTongCopy from "@/views/ZhiqiTongCopy.vue";
import zinnegtiCopy from "@/views/zinnegtiCopy.vue";
import aExistingCopy from "@/views/aExistingCopy.vue";
import aExisting from "@/views/aExisting.vue";
import zhiqiTong from "@/views/ZhiqiTong.vue";
Vue.use(VueRouter)

const routes = [
    {
        path: '',
        name: 'layout',
        component: Layout,
        children: [
            {
                path: '/',
                name: 'home',
                component: HomeView

            }, {
                path: '/login', // 定义访问路径
                name: 'Login', // 路由名称（可选）
                component: Login // 引入的组件
            }, {
                path: '/register', // 定义访问路径
                name: 'register', // 路由名称（可选）
                component: Register // 引入的组件
            },
            {
                path: '/imgShow',
                name: 'imgShow',
                component: ImgShow
            },
            {
                path: '/PersonalInformation',
                name: 'changePassword',
                component: changePassword
            },
            {
                path: '/InformationAdmin',
                name: 'InformationAdmin',
                component: InformationAdmin
            },
            {
                path: '/industryChain',
                name: 'industryChain',
                component: industryChain
            },
            //ai报告生成
            {
                path: '/declaration',
                name: 'declaration',
                component: aExisting
            },

            {
                path: '/historicalRecords',
                name: 'historicalRecords',
                component: historicalRecords

            },
            //知企通
            {
                path: '/Knowledge',
                name: 'Knowledge',
                component: zhiqiTong

            },
            {
                path: '/FixedKnowledge',
                name: 'FixedKnowledge',
                component: ZhiqiTongNew

            },

            //智能体
            {
                path: '/intelligentAgent',
                name: 'intelligentAgent',
                // component: zinnegtiCopy
                component: copy

            },

            /**
             * 科创自检
             */
            {
                path: '/inspection',
                name: 'inspection',
                component: inspection
            },
            /**
             * 概念验证
             */
            {
                path: '/concept',
                name: 'concept',
                component: concept
            },

            /**
             * 概念验证
             */
            {
                path: '/sandTable',
                name: 'sandTable',
                component: sandTable
            },

            //知识图谱
            {
                path: '/Industry',
                name: 'Industry',
                component: Industry
            },

            {
                path: '/execl',
                name: 'execl',
                component: execl
            },
            {
                path: '/KnowledgeOne',
                name: 'KnowledgeOne',
                component: ZhiqiTong1
            },
            {
                path: '/KnowledgeTwo',
                name: 'KnowledgeTwo',
                component: ZhiqiTong2
            },
            {
                path: '/KnowledgeThree',
                name: 'KnowledgeThree',
                component: ZhiqiTong3
            },

            {
                path: '/KnowledgeFour',
                name: 'KnowledgeFour',
                component: ZhiqiTong4

            },

            {
                path: '/Display',
                name: 'Display',
                component: display
            },
            {
                path: '/MySecondLevel',
                name: 'MySecondLevel',
                component: MySecondLevel
            },
            {
                path: '/PersonalInformation',
                name: 'PersonalInformation',
                component: PersonalInformation
            },
            {
                path: '/conceptCopy',
                name: 'conceptCopy',
                component: conceptCopy
            }
        ]
    },


]


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})



const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router
